import { IndicatorOrLaw } from "../../interfaces/Indicator";
import Indicator from "../../views/IndicatorDisplay/components/Indicator/Indicator";
import Laws from "../../views/IndicatorDisplay/components/Indicator/Laws";

export const IndicatorMapper = ({
    indicators,
    period,
}: {
    indicators: IndicatorOrLaw[];
    period: number;
}) => {

    return (
        <div className="flex justify-center items-center flex-col">
            {indicators && indicators.length > 0 &&
                indicators.map((item, index) => (
                    <div key={`${item.type}-${item.id}-${index}`} className="w-full">
                        {item.type === "indicator" ? (
                            <Indicator
                                key={item.id}
                                id={item.id}
                                breadcrumbs={item.breadcrumbs}
                                descripcion={item.descripcion}
                                titulo={item.titulo}
                                state={
                                    item.evaluaciones && item.evaluaciones[period] != null
                                        ? (isNaN(Number(item.evaluaciones[period])) ? null : Number(item.evaluaciones[period]))
                                        : null
                                }
                                notas={item.notas}
                                fuente={item.fuente}
                                graphics={item.graphics}
                                variable_indicador={item.variable_indicador}
                                data={item.data}
                                documento_informativo={item.documento_informativo}
                                investigaciones={item.investigaciones}
                                ods={item.ods}
                                grupos_prioritarios={item.grupos_prioritarios}
                                dimension={item.dimension}
                                subdimension={item.subdimension}
                                capa_mapa={item.capa_mapa}
                            />
                        ) : (
                            <Laws
                                key={`${item.type}-${item.id}-${index}`}
                                titulo={item.titulo}
                                breadcrumbs={item.breadcrumbs}
                                descripcion={item.descripcion}
                                ods={item.ods}
                                grupos_prioritarios={item.grupos_prioritarios}
                                url={item.url}
                                pdf={item.pdf}
                                state={
                                    item.evaluaciones && Object.keys(item?.evaluaciones).length > 0
                                        ? item.evaluaciones?.valoracion &&
                                        item.evaluaciones?.valoracion.toLowerCase()
                                        : null
                                }
                                id={item.id}
                                dimension={item.dimension}
                                subdimension={item.subdimension}
                            />
                        )}
                    </div>
                ))}
        </div>
    );
};

export default IndicatorMapper;